// extracted by mini-css-extract-plugin
export default {"alert":"FormNoLayoutAlert_alert__PeZEH","title":"FormNoLayoutAlert_title__mJA6y","icon":"FormNoLayoutAlert_icon__1nwJs"};